module.exports = __webpack_public_path__ + "img/icon-delete.b0321cb3.svg";